import React, { useRef } from 'react';
import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { getToken, saveToken, getTokenExpirationTime } from '../utils';

function scheduleNextRefresh(iframe, origin) {
  var token = getToken();
  var now = Math.floor(Date.now() / 1000);
  var tokenExpiresIn = Math.round((getTokenExpirationTime(token) - now) * 0.9);
  setTimeout(function () {
    iframe.current.contentWindow.postMessage({
      type: 'get-token'
    }, origin);
  }, tokenExpiresIn * 1000);
}

function TokenRefresh() {
  var _useConfig = useConfig(),
      accountsUrl = _useConfig.accountsUrl;

  var iframe = useRef(null);

  var _onLoad = function onLoad() {
    // schedule first token refresh
    scheduleNextRefresh(iframe, accountsUrl);
    window.addEventListener('message', function (e) {
      if (e.data && e.data.type === 'set-token') {
        saveToken(e.data.data); // schedule next token refresh

        scheduleNextRefresh(iframe, accountsUrl);
      }
    });
  };

  return React.createElement("iframe", {
    ref: iframe,
    height: "1",
    title: "refresh",
    src: "".concat(accountsUrl, "refresh-token"),
    frameBorder: "0",
    onLoad: function onLoad() {
      return _onLoad();
    }
  });
}

export default TokenRefresh;